import { ApplicationConfig, importProvidersFrom, isDevMode } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';

import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { provideServiceWorker } from '@angular/service-worker';
import { AuthGuard } from '@shared/guard/authorization.guard';
import { environment } from '@env/environment';
import { ApiModule } from './api/api.module';
import { tokenInterceptor } from './interceptors/token.interceptor';

export const MY_DATE_FORMATS = {
   parse: {
      dateInput: 'DD MMM YYYY',
   },
   display: {
      dateInput: 'DD MMM YYYY',
      monthYearLabel: 'MMM YYYY',
      dateA11yLabel: 'DD/MM/YYYY',
      monthYearA11yLabel: 'MMMM YYYY',
   },
};

export const appConfig: ApplicationConfig = {
   providers: [
      provideHttpClient(withFetch()),
      provideRouter(routes),
      provideAnimations(),
      provideAnimations(),
      provideHttpClient(withInterceptors([tokenInterceptor])),
      importProvidersFrom(ApiModule.forRoot({ rootUrl: environment.customApiUrls[location.host] ?? environment.defaultApiUrl })),
      AuthGuard,
      provideMomentDateAdapter(MY_DATE_FORMATS),
      provideServiceWorker('ngsw-worker.js', {
         enabled: !isDevMode(),
         registrationStrategy: 'registerWhenStable:30000',
      }),
   ],
};
